import defaultImg from '../assets/images/default-user-image.png'
import { Skeleton } from 'primereact/skeleton';
import classNames from 'classnames';

const CandidatoDetalhe = (props) => {   

    const wrapperCandSit = classNames("flex flex-wrap candidato-detalhe",{
        "candidato-detalhe-sem-situacao": props?.situacao?.includes("Deferido"),
        "justify-content-between": !props?.situacao?.includes("Deferido")
    })

    return (        
        <div className="bloco-dados candidato align-start">                        
            <div className="candidato-foto">
                {props?.skeleton?
                    <Skeleton width="100%" height="100%" shape="circle"></Skeleton>
                    :<img alt="foto" src={props.foto || defaultImg}/>
                }
            </div>            
            <div className="candidato-right">
                <div className="candidato-nome">
                    {props?.skeleton?
                        <Skeleton className="candidato-skeleton-bar" width="calc(100% - 20px)" height="calc(18px + 1.5vh)"></Skeleton>
                        :props.nomeCand || "nome"
                    }
                </div>
                {!props?.skeleton &&                    
                    <div className={wrapperCandSit}>
                        <div className="candidato-partido">
                            {props.partido || "partido"}
                        </div>
                        <span  className="candidato-situacao">
                            {!props?.situacao?.includes("Deferido") && props?.situacao}
                        </span> 
                    </div>
                }               
                {props?.skeleton?                                  
                    
                    <div className="candidato-resultado">                   
                        <Skeleton className="candidato-skeleton-bar candidato-skeleton-votos" width="30%" height="calc(18px + 1.8vh)"></Skeleton>    
                    </div>

                    :<div className="candidato-resultado">                        
                        <div className="candidato-numero">
                            {props.numeroCand || 0}
                        </div>                        
                        <div className="candidato-votos-container">
                            Votos
                            <div className="candidato-votos">
                                {props?.votos?.toLocaleString()}                            
                            </div>                        
                        </div>
                    </div>   
                }
            </div>
        </div>
    );
}

export default CandidatoDetalhe;